export function efficiencyYBIValidate(res){
    var result = true;

    result = validateOjects(res.data);

    return result;
}

function validateOjects(data) {
    var is_all_ok = true;

    for(var state in data){
        for(var date in data[state]){
            is_all_ok = (typeof data[state][date] === 'object' 
            && typeof data[state][date].total_shipments === "number" 
            && typeof data[state][date].delivered_total === "number" 
            && typeof data[state][date].delivered_pct === "string" 
            && typeof data[state][date].returned_total === "number" 
            && typeof data[state][date].returned_pct === "string" 
            && typeof data[state][date].others_total === "number" 
            && typeof data[state][date].others_pct === "string")
        }

        if (is_all_ok == false) return false;
    }

    return is_all_ok;
}